import { FC, useLayoutEffect, useMemo } from "react";
import { RadioGroup, Stack, VStack, Text } from "@chakra-ui/react";

import { useGetSbpTransferBanksQuery } from "../../../../../api/sbpTransfer";
import { useSbpTransferStore } from "../../../../../store/sbpTransferStore.ts";
import { SbpTransferBanksPageBankItem } from "./SbpTransferBanksPageBankItem.tsx";

export const SbpTransferBanksPageBankList: FC = () => {
  const { data } = useGetSbpTransferBanksQuery();
  const bankSearch = useSbpTransferStore(s => s.bankSearch);
  const selectedBankSchema = useSbpTransferStore(s => s.selectedBankSchema);
  const setSelectedBankSchema = useSbpTransferStore(s => s.setSelectedBankSchema);

  useLayoutEffect(() => {
    setSelectedBankSchema("");
  }, []);

  const banks = useMemo(() => {
    const searchValue = bankSearch.toLowerCase().trim();
    if (!searchValue) {
      return data;
    }

    return data?.filter(b => b.bankName?.toLowerCase().includes(searchValue));
  }, [data, bankSearch]);

  if (banks?.length === 0) {
    return (
      <Text mt="30px" textAlign="center">
        Нет доступных банков для перевода
      </Text>
    );
  }

  return (
    <Stack mt="20px" overflow="auto">
      <RadioGroup onChange={setSelectedBankSchema} value={selectedBankSchema}>
        <VStack align="stretch" spacing="10px">
          {banks?.map(bank => (
            <SbpTransferBanksPageBankItem
              key={bank.schema}
              bank={bank}
              isChecked={selectedBankSchema === bank.schema}
            />
          ))}
        </VStack>
      </RadioGroup>
    </Stack>
  );
};
